export default __webpack_public_path__ + "static/media/Dia-internacional-de-Luta-das-Mulheres.f8122f44.jpg";